import Cookies from 'universal-cookie'
import { GET_CATEGORIES_REQUEST, GET_CATEGORIES_RESPONSE, CATEGORY_CHECKED, SEARCH } from './topPanelActions'

const cookies = new Cookies()

// Updates the state with categories received from the server
const topPanel = function (state = { categories: [], searchText: '' }, action) {
  switch (action.type) {
    case GET_CATEGORIES_RESPONSE:
    // checking if there are cookies with selected categories
      const coockieCategories = cookies.get('selectedCategories') || []
      return { ...state,
        categories: action.categories.map(category => ({
          id: category.id,
          name: category.name,
          isSelected: coockieCategories.some((e) => e.id === category.id)
        }))
      }

    case GET_CATEGORIES_REQUEST:
    // Does nothing right now, but in future we can set splash screen or some other indicator
      return state

    case CATEGORY_CHECKED:
      const checkedCategory = state.categories.find((c) => c.id === action.categoryId)
      checkedCategory.isSelected = !checkedCategory.isSelected

      // saving chosen categories in cookies with ~1 year expiration
      const selectedCategories = state.categories.filter(c => c.isSelected)
      cookies.set('selectedCategories', selectedCategories, { maxAge: 977616000 })

      return { ...state, categories: [...state.categories] }

    case SEARCH:
      return { ...state, searchText: action.text }

    default:
      return state
  }
}

export default topPanel
